export const enum STRAPI_URL {
  BANNERS = '/api/banners',
  SLIDES = '/api/slides',

  DOCUMENTS = '/api/documents',
}
